import '../../dmView/style/App.css';
import { useState, useEffect, useRef } from 'react';
import Icon from './Icon';
import YouTubeEmbed from '../../dmView/components/EncounterColumn/YouTubeEmbed.js';
import io from 'socket.io-client';
import { useParams } from 'react-router-dom';
import defaultBackground from '../../dmView/pics/backgrounds/happyTavern.png';
import { backendUrl, cheaterMode, DEFAULT_PREFS, effectImgMap, conditionImgMap } from '../../dmView/constants.js';
import IdlePopUp from '../../dmView/components/IdlePopUp.js';
import axios from 'axios';

function getVideoLink(thumbnailLink) {
    const videoId = thumbnailLink.split("vi/")[1].split('/max')[0];
    if (videoId) {
        let embedUrl = "https://www.youtube.com/embed/" + videoId

        const params = {
            controls: 0,
            mute: 1,
            rel: 0,
            autoplay: 1,
            loop: 1,
            playlist: videoId
        }

        // Mute by default and turn off controls so they dont show everytime on hover
        const queryParams = new URLSearchParams(params).toString();
        embedUrl += `?${queryParams}`;
        return {type: 'youtube', src: embedUrl}

    } else {
        console.error('Invalid YouTube URL');
        return {type: 'image', src: defaultBackground};
    }
}
// monster, player, global
const showIcon = (creature, hideEnemies) => {
    if(cheaterMode){
        return true
    }

    let isGoodGuy = creature.alignment === "ally" || creature.alignment === "pet"
    let isPlayer = creature.type === 'player'

    // Individual takes priority whether its a player good or bad or pet
    if(creature.hidden)
        return false 
    // then check global hide button  
    else if(hideEnemies) {
        // Return true if its a good guy or a player, false if bad guy or global
        return isGoodGuy || isPlayer;
    }
    
    // if global check is visible then show everyone that isnt individually hidden
    return true
}

const defaultMonsterOptions = DEFAULT_PREFS.playerViewGlobalOptions.monsterOptions
const defaultAllyOptions = DEFAULT_PREFS.playerViewGlobalOptions.allyOptions
const defaultPlayerOptions = DEFAULT_PREFS.playerViewGlobalOptions.playerOptions
const defaultTableViewOptions = DEFAULT_PREFS.playerViewGlobalOptions.tableViewOptions

const gridMap = {
    'Center': { col: '2', row: '2' }, // only in column 1 and row 1

    'Top': { col: '2', row: '1' }, // only in column 2 and row 1
    'Bottom': { col: '2', row: '3' },

    'Left': { col: '1', row: '1/4' }, // stay in column 1, but span from row line 1-4 (very top to bottom)
    'Right': { col: '3', row: '1/4' },
};

// Add these classes to rotate
const tableViewCss = { 
    'Top': 'tableViewTop', 
    'Bottom': 'tableViewBottom',
    'Left': 'tableViewLeft', 
    'Right': 'tableViewRight',
};

const defaultTableOptions = {
    showGrid: window.location.href.includes("grid")
}

let playViewControlsTimeout = null;
const tableView = window.location.href.includes("table");

function PlayerPage() {
    if(!document.title.includes('PlayerView'))
        document.title = document.title + ' - PlayerView' + (tableView ? ' TvTable' : '')

    const [playerViewBackground, setPlayerViewBackground] = useState({type: "image", src: defaultBackground});
    const [creatures, setCreatures] = useState(null);
    const [turnNum, setTurnNum] = useState(0);
    const [roundNum, setRoundNum] = useState(0);
    const [hideEnemies, setHideEnemies] = useState(true);
    const [hideAll, setHideAll] = useState(false);

    const [useGlobalOptions, setUseGlobalOptions] = useState(false);
    const [playerOptions, setPlayerOptions] = useState(defaultPlayerOptions);
    const [monsterOptions, setMonsterOptions] = useState(defaultMonsterOptions);
    const [allyOptions, setAllyOptions] = useState(defaultAllyOptions);

    //TODO add showGrid
    const [tableViewOptions, setTableViewOptions] = useState(defaultTableViewOptions);

    const [iconSize, setIconSize] = useState({width: 200, height: 240});
    const [encounterName, setEncounterName] = useState(null);
    const [encounterGuid, setEncounterGuid] = useState(null);
    const [username, setUsername] = useState(null);

    const [showPopup, setShowPopup] = useState(false);

    const { sessionID } = useParams();

    const socketRef = useRef(null)
    const [socket, setSocket] = useState(null);

    const useGlobalOptionsRef = useRef(useGlobalOptions);
    const encounterNameRef = useRef(encounterName);
    const encounterGuidRef = useRef(encounterGuid);
    const usernameRef = useRef(null);

    useEffect(() => {
        usernameRef.current = username;
    }, [username]);

    useEffect(() => {
        encounterNameRef.current = encounterName;
    }, [encounterName]);

    useEffect(() => {
        encounterGuidRef.current = encounterGuid;
    }, [encounterGuid]);

    useEffect(() => {
        useGlobalOptionsRef.current = useGlobalOptions;
    }, [useGlobalOptions]);


    function savePlayerViewOpen(isOpen) {
        window.localStorage.setItem("playerViewOpen", isOpen);
    }

    // If this gets rendered EVER make sure this is true
    savePlayerViewOpen(true)

    useEffect(() => {
        const handleTabClose = () => {
            savePlayerViewOpen(false); 
        };

        window.addEventListener('beforeunload', handleTabClose);

        return () => {
            window.removeEventListener('beforeunload', handleTabClose);
        };
    }, []);

    useEffect(() => {
        if (!socketRef.current) {
            const newSocket = io(backendUrl);
    
            socketRef.current = newSocket;
            setSocket(newSocket);
        }

        return () => {
            if (socketRef.current) {
                console.log(`Disconnecting socket: ${socketRef.current.id}`);
                socketRef.current.disconnect();
            }
        };
    }, []); 

    useEffect(() => {
        if (!socket) return;

        socket.on('pvPing', () => {
            let src = tableView ? "PlayerViewTable" : "PlayerView";
            const payload = {
                src,
                username: usernameRef.current,
                socketId: socket.id,
                sessionId: sessionID,
                encounterName: encounterNameRef.current,
                encounterGuid: encounterGuidRef.current,
            }
            axios.post(`${backendUrl}/keepalive`, payload)
        });
            
    }, [socket]);

    useEffect(() => {
        if(socket) {

            const checkIdleClock = (serverRestart) => {
                // Do not reset the idle clock on server restarts
                // If the server has restarted, we want to keep the idle clock running
                let dmAction = !serverRestart
                // If the dm has taken an action, reset the idle clock
                // If the timer is null, start the idle clock
                if(dmAction || playViewControlsTimeout === null) {
                    startPlayViewControlsMonitor();
                } else {
                    console.log("No Dm Action, not resetting idle clock")
                }
            }

            function startPlayViewControlsMonitor() {

                // Clear any existing timer
                if (playViewControlsTimeout) {
                    console.log("Reset Idle Clock")
                    clearTimeout(playViewControlsTimeout);
                } else {
                    console.log("Starting New Idle Clock")
                }

                // Set up a new timer for 12 hours 
                playViewControlsTimeout = setTimeout(() => {
                    // show the popup and kill the connection to the backend
                    setShowPopup(true)
                    socket.emit("noDmActionTimeOut",  encounterNameRef.current, encounterGuidRef.current);
                    socket.disconnect()
                // 6 hours
                }, 6 * 3600000);
            }

            socket.on('connect', () => {
                console.log(`Connected to Playerview - ${socket.id}`);
                socket.emit('connectPlayerview', sessionID, "newui7/17");
                // always start idle clock on connect
            });

            socket.on('reconnect_attempt', (attemptNumber) => {
                console.log(`Socket.IO reconnect attempt #${attemptNumber}`);
                socket.emit("logReconnectAttempt", attemptNumber);
            });

            socket.on('disconnect', reason => {
                console.log('Socket disconnected:', reason);
            });

            const configureSizePrefs = (options) => {
                let iconSizeModifier = options.iconSize;

                if(tableView) {
                    let tvTeamSize = options.tableViewOptions.teamSize;
                    iconSizeModifier += parseInt(tvTeamSize);
                }

                let w = 200 + (10 * iconSizeModifier)
                let h = 240 + (12 * iconSizeModifier)

                console.log("Icon Size", iconSizeModifier, w, h)

                setIconSize({width: w, height: h})
            }

            // newPrefs contains useGlobal and all the preferences
            socket.on('sendPlayerViewGlobalPrefs', (newPrefs) => {
                if(newPrefs.useGlobalPvOptions) {
                    console.log("Using New Global Options")
                    setPvOptions(newPrefs.playerViewGlobalOptions)
                    configureSizePrefs(newPrefs.playerViewGlobalOptions)
                }
                console.log("Recieved Global Controls", newPrefs)
                setUseGlobalOptions(newPrefs.useGlobalPvOptions)
            });

            socket.on('sendPlayerViewCreatures', (encounterCreaturesRes) => {
                console.log("Recieved Creatures", encounterCreaturesRes)
                checkIdleClock(encounterCreaturesRes.serverRestart)
                
                let creaturesWithIndex = encounterCreaturesRes.creatures.map((c, index) => { return {...c, initIndex: index} })
                setCreatures([...creaturesWithIndex])
            });

            socket.on('sendPlayerViewControls', (encounterRes) => {

                console.log("Recieved Player View Controls", encounterRes)
                checkIdleClock(encounterRes.serverRestart)

                setRoundNum(encounterRes.roundNum)
                setTurnNum(encounterRes.turnNum)
                setHideEnemies(encounterRes.hideEnemies)
                setHideAll(encounterRes.hideAll)

                if(!useGlobalOptionsRef.current) {
                    console.log("Using Encounter Options")
                    setPvOptions(encounterRes.playerViewOptions)

                    let options = encounterRes.playerViewOptions
                    configureSizePrefs(options)
                }

                
                setEncounterName(encounterRes.encounterName)
                setEncounterGuid(encounterRes.encounterGuid)
                setUsername(encounterRes.username)
                
                if(encounterRes.backgroundGuid === 'defaultError') {
                    console.log("Image not found setting to default")
                    setPlayerViewBackground({type: "image", src: defaultBackground})
                } else if(encounterRes.backgroundGuid === 'default') {
                    setPlayerViewBackground({type: "image", src: defaultBackground})
                } else {
                    setPlayerViewBackground(
                        encounterRes.backgroundGuid.includes('youtube.com')
                            ? getVideoLink(encounterRes.backgroundGuid)
                            : {type: 'image', src: encounterRes.backgroundGuid}
                    )
                }
            });

            socket.on('stopStreaming', () => {
                setCreatures(null)
                setTurnNum(0);
                setRoundNum(0);
                setHideEnemies(true);
                setHideAll(false);
                setPlayerOptions(defaultPlayerOptions);
                setMonsterOptions(defaultMonsterOptions);
                setAllyOptions(defaultAllyOptions);
                setTableViewOptions(defaultTableViewOptions);
                setPlayerViewBackground({type: "image", src: defaultBackground})
            });
        }

        // Clean up the socket connection on component unmount
        return () => {
            if(socket) {
                console.log(`Disconnecting from Playerview - ${socket.id}`);
                socket.disconnect();
            } 
        };
    }, [socket]);

    const setPvOptions = (playerViewOptions) => {
        setPlayerOptions({...playerViewOptions.playerOptions})
        setAllyOptions({...playerViewOptions.allyOptions})
        setMonsterOptions({...playerViewOptions.monsterOptions})
        setTableViewOptions({...playerViewOptions.tableViewOptions})
    }

    // Set up creatures in positions json to include all the different positions
    let creaturesInPositions = {
        [playerOptions.position]: [],
        [allyOptions.position]: [],
        [monsterOptions.position]: [],
    }

    // Different positions
    if(!(playerOptions.position === allyOptions.position === monsterOptions.position) && creatures !== null) {
        creatures.forEach(c => {
            if(c.type === 'player') {
                creaturesInPositions[playerOptions.position].push(c)
            } else if ((c.alignment === 'ally' || c.alignment === 'pet') && c.type !== 'player') {
                creaturesInPositions[allyOptions.position].push(c)
            } else if(c.alignment === 'enemy'){
                creaturesInPositions[monsterOptions.position].push(c)
            }

        });
    } else {
        // If all the same position just put them all in one spot
        creaturesInPositions = {
            [playerOptions.position]: creatures,
        }
    }


    const squareSize = 96; // 96 px is close enough/about an inch
    // add an extra row to slightly over fill the screen filling any gaps
    const columns = Math.floor(window.screen.width / squareSize) + 1;
    const rows = Math.floor(window.screen.height / squareSize) + 1; 
    
    let hideNameCount = 1;
    let hasCenter = creaturesInPositions['Center'] || creaturesInPositions['Top'] || creaturesInPositions['Bottom']

    let gridSizes = {
            colSize: '',
            rowSize: '1fr 1fr 1fr'
        };

    if(hasCenter) {
        let colWithSize = '0fr 2fr 0fr'
        
        let hasLeft = creaturesInPositions['Left'] && creaturesInPositions['Left'].length > 0
        let hasRight = creaturesInPositions['Right'] && creaturesInPositions['Right'].length > 0
        colWithSize = `${hasLeft ? '1fr' : '0fr'} 2fr ${hasRight ? '1fr' : '0fr'}`

        gridSizes.colSize = colWithSize
    } else {
        gridSizes.colSize = '1fr .8fr 1fr'
    }

    const getHiddenName = (creatureName, showName) => {
        let name = creatureName
        if(!showName && showName !== undefined) {
            name = `Creature ${hideNameCount}`
            hideNameCount += 1;
        }

        return name;
    }

    const effectsFound = creatures && creatures.some(creature => creature.effects && creature.effects.length > 0);
    let allEffects = [];
    if(effectsFound) {
        creatures.forEach(creature => {
            if(creature.effects && creature.effects.length > 0) {
                allEffects.push(...creature.effects);
            }
        });

        allEffects = Array.from(new Set(allEffects));
    }

    return (
        <>  
            <div className='pvBackgroundContainer'>
                {playerViewBackground.type === "youtube" ?  (
                    <YouTubeEmbed embedUrl={playerViewBackground.src} page={tableView ? 'tvplayerView' : 'playerView'} mapSizeMod={tableViewOptions.mapSize}/>
                ) : (
                    <div className="pvbackground" style={{
                        width: tableView ? (100 + parseInt(tableViewOptions.mapSize)*5) + '%' : '100%',
                        height: tableView ? (100 + parseInt(tableViewOptions.mapSize)*5) + '%' : '100%',
                        backgroundImage: playerViewBackground.type === "image" && playerViewBackground.src 
                            ? `url(${playerViewBackground.src})` 
                            : 'none',
                    }} />
                )}
            </div>
            
            <div className='iconsContainer playerViewAdds'>
                {tableViewOptions.showGrid && 
                    <div
                        className="fullscreenGridOverlay"
                        style={{
                            gridTemplateColumns: `repeat(${columns}, 1fr)`,
                            gridTemplateRows: `repeat(${rows}, 1fr)`,
                            
                        }}
                    >
                        {Array.from({length: columns * rows}).map((_, i) => 
                            <div className={'fullscreenGridSquare'} style={{
                                width: '1in'
                            }} key={i} />
                        )}
                    </div>
                }


                {roundNum !== 0 && 
                    <>
                        {tableView ? (
                            <div style={{width: '100vw', height: '100vh'}}>
                                {['Top', 'Bottom', 'Left', 'Right'].map(pos => {
                                    let marginString = "";
                                    let mbt = (parseInt(tableViewOptions.iconMargin)*1.2) + "%";
                                    let mlr = (parseInt(tableViewOptions.iconMargin)*3.3) + "%";
                                    if(pos === "Top") marginString = `${mbt} 0 0 ${mlr}`;
                                    else if(pos === "Bottom") marginString = `0 ${mlr} ${mbt} 0`;
                                    else if(pos === "Left") marginString = `0 0 ${mbt} ${mlr}`;
                                    else if(pos === "Right") marginString = `${mbt} ${mlr} 0 0`;
                                    return (
                                        <div className={`roundNum roundNum${pos}`} style={{display: "flex", alignItems: "center", alignItems: "flex-end", margin: marginString}} key={'roundNum' + pos}>
                                                {effectsFound && (pos === "Top" || pos === "Bottom") && (
                                                    <div className='' >
                                                        {allEffects.map((effectName) => (
                                                            <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>  
                                                                <div className='allEffectsLabel' style={{textDecoration: "none"}}>{effectName.replace(" Condition", "")}</div>
                                                                <img className='pvAllEffectImage'
                                                                    key={effectName}
                                                                    src={effectImgMap[effectName] || conditionImgMap[effectName]}
                                                                    alt={effectName}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                <div className='numUnderline'>
                                                    {roundNum}
                                                </div>
                                        </div>
                                    )
                                })}
                            </div>
                        ) : (
                            <div className='roundNum roundNumNormal'>
                                <div className='numUnderline'>
                                    {roundNum}
                                </div>
                                {effectsFound && (
                                    <div className='pvAllEffectsContainer'>
                                        {allEffects.map((effectName) => (
                                            <div style={{display: "flex", alignItems: "center"}}>  
                                                <img className='pvAllEffectImage'
                                                    key={effectName}
                                                    src={effectImgMap[effectName] || conditionImgMap[effectName]}
                                                    alt={effectName}
                                                />
                                                <div className='allEffectsLabel' style={{textDecoration: "none"}}>{effectName.replace(" Condition", "")}</div>
                                            </div>
                                            
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                }

                {showPopup && 
                    <IdlePopUp page={'PlayerView'}/>
                }
                
                {creatures === null ? (
                    <div className=" firstLoadMenuContainer">
                        <div className="firstLoadMenu">
                            <div className="homepageTopContent">
                                <h1>DmBuddy.com</h1>
                                <span>Home Brew Focused Encounter Builder and Player View</span>
                                <span className='firstLoadExtra'>(with Dnd Beyond Importing)</span>
                                <div className='noStreamingDesc'>Dm not streaming... get it together man...</div>
                            </div>
                            <a className='helpLink' href='/help'>DmBuddy.com/help</a>
                        </div>
                    </div>
                ) : (
                    <>
                        {!hideAll &&
                            <>
                                {tableView ? (
                                    <>
                                        {['Top', 'Bottom', 'Left', 'Right'].map(pos => {
                                            if(tableViewOptions?.position.split(',').includes(pos)) {
                                                return (
                                                    <div className={`cardTableViewContainer ${tableViewCss[pos]}`} style={{paddingBottom: '10px'}} key={'tableView' + pos}>
                                                        <div className="cardContainer" style={{marginBottom: (parseInt(tableViewOptions.iconMargin)*5) + '%' }}>
                                                            {creatures.map((creature) => { 

                                                                let options;
                                                                if(creature.type === 'player') options = playerOptions
                                                                else if(creature.alignment === 'ally' || creature.alignment === 'pet') options = allyOptions
                                                                else options = monsterOptions

                                                                let name = getHiddenName(creature.name, options.showName);

                                                                // Specifically in tablew view shorten names 
                                                                if(name.length > 18) {
                                                                    let nameParts = name.split(" ");
                                                                    name = nameParts[0] + " " + nameParts[1] + "..."
                                                                }

                                                                return showIcon(creature, hideEnemies) 
                                                                    ? <Icon key={creature.creatureGuid} isTurn={turnNum === creature.initIndex+1} creature={{...creature, name}} iconOptions={options} iconSize={iconSize}/>
                                                                    : null
                                                            })}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}
                                    </>
                                ) : (
                                    <div className="cardGrid" style={{
                                        gridTemplateColumns: gridSizes.colSize,
                                        gridTemplateRows: gridSizes.rowSize,
                                    }}>
                                        {['Center', 'Top', 'Bottom', 'Left', 'Right'].map(pos => {
                                            if(creaturesInPositions[pos])
                                                return (
                                                        <div className="cardContainer" key={'pv' + pos} style={{ 
                                                            gridColumn: gridMap[pos].col, 
                                                            gridRow: gridMap[pos].row
                                                        }}>
                                                            {creaturesInPositions[pos].map((creature, index) => { 
                                                                let options;
                                                                if(creature.type === 'player') options = playerOptions
                                                                else if(creature.alignment === 'ally' || creature.alignment === 'pet') options = allyOptions
                                                                else options = monsterOptions

                                                                let name = getHiddenName(creature.name, options.showName); ;

                                                                return showIcon(creature, hideEnemies) 
                                                                    ? <Icon key={creature.creatureGuid} isTurn={turnNum === creature.initIndex+1} creature={{...creature, name}} iconOptions={options} iconSize={iconSize}/>
                                                                    : null
                                                            })}
                                                        </div>
                                                )
                                        })}
                                    </div>
                                )}
                            </>
                        }
                    </> 
                )}
            </div> 
        </>
    );
}


export default PlayerPage;
